// @use '@sass/core/helpers/rfs' as *;
import styled from 'styled-components';
import { Formik, Form, Field } from 'formik';

export const LoginFormWrapper = styled.div`
  border-radius: 0.5em;
  input {
    border: 1px solid var(--color-muted-lines);
    border-radius: 0.4em;
    width: 100%;
    margin: 0.2em;
  }
  button {
    width: 100%;
    margin: 0.2em;
    background: var(--color-ui-blue);
    color: white;
    border: none;
    border-radius: 0.4em;
    line-height: 3em;
    font-weight: bold;
    margin-top: 1em;
  }
  .field_error {
    color: var(--color-ui-orange);
    padding: 0.2em 1.6em;
    font-size: 0.8rem;
  }
`;

export const FormHeader = styled.div`
  text-align: center;
  h3 {
    margin: 0 0 2rem 0;
  }
`;

export const FormFieldsGrid = styled.div`
  display: grid;
  column-gap: 2rem;
  row-gap: 1.4rem;
  @media (min-width: 1024px) {
    grid-template-columns: repeat(6, 1fr);
  }
`;

export const StyledForm = styled(Form)`
  margin-bottom: 2rem;
  max-width: 68rem;
  margin-left: auto;
  margin-right: auto;
`;

export const FormLabel = styled.label`
  display: block;
  ${(props) => {
    if (props.checkbox) {
      return `
        display: grid;
        grid-template-columns: min-content 1fr;
        column-gap: 1rem;
      `;
    }
  }}
`;

export const FormField = styled.div`
  /* grid-column: ${(props) => props.gridColumn || 'auto / 0'}; */
  grid-column: ${(props) => (props.cols ? `auto / span ${props.cols}` : 'auto / span 3')};
  label {
    span {
      display: block;
      font-weight: 500;
      padding: 0.4em 0;
      small {
        color: hsla(183, 83%, 54%, 1);
      }
    }
  }
  input {
    border: 1px solid var(--color-dark-base);
    width: 100%;
    border-radius: 3px;
  }
  input[type='checkbox'] {
    width: auto;
  }
  ${(props) => {
    if (props.fullWidth) {
      return `grid-column: 1 / -1;`;
    }
    if (props.columns) {
      return `grid-column: auto / span ${props.columns};`;
    }
  }}
`;

export const DropZoneField = styled.div`
  border: 1px dotted var(--color-ui-dark);
  background: white;
  padding: 3rem 6rem;
  text-align: center;
  border-radius: 4px;
  ul {
    list-style: none;
    margin: 0;
    padding: 0;
    li {
      font-weight: bold;
      li {
        color: red;
        font-weight: normal;
      }
    }
  }
`;

export const DropZoneFieldLoading = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  &:not(:last-child) {
    margin-bottom: 2rem;
  }
  .message {
    margin-bottom: 0.6rem;
  }
`;

export const SelectWrapper = styled.div`
  position: relative;
  border: 1px solid var(--color-dark-base);
  width: 100%;
  border-radius: 3px;
  select {
    width: 100%;
  }
  svg {
    position: absolute;
    top: 50%;
    right: 0.9rem;
    transform: translateY(-50%);
    pointer-events: none;
    width: 1em;
    height: 1em;
  }
`;

export const FieldErrorMessage = styled.div`
  color: red;
`;

export const FieldHelper = styled.small`
  display: block;
  font-size: 0.85rem;
  color: var(--color-text-neutral);
  padding: 0.2em 0.4em;
`;

export const ResponseErrorMessage = styled.div`
  color: red;
  font-size: 1.4rem;
  margin-bottom: 1.4rem;
  text-align: center;
`;

export const FormActions = styled.div`
  border: 1px solid red;
`;

export const FormFooter = styled.div`
  display: grid;
  grid-template-columns: 1fr min-content;
  grid-template-areas: 'notes actions';
  margin-top: 2rem;
  .notes {
    grid-area: notes;
    align-self: center;
  }
  .actions {
    grid-area: actions;
    display: flex;
    align-items: flex-start;
  }
`;

export const Button = styled.button`
  border: none;
  display: inline-block;
  line-height: 3;
  padding: 0 3em;
  background: var(--color-ui-blue);
  color: white;
  font-weight: 600;
  border-radius: 3em;
  white-space: nowrap;
`;

export const StyledLoginForm = styled(Form)`
  background: var(--color-muted-base);
  padding: 3rem 6rem;
  margin-bottom: 2rem;
  max-width: 88rem;
  margin-left: auto;
  margin-right: auto;
  ${FormFieldsGrid}, ${FormFooter} {
    max-width: 58rem;
    margin-left: auto;
    margin-right: auto;
  }
`;
